import { defineAction } from '~/prix'
import userFetchAction from './userFetch.action.json' with { type: 'json' }
import { z } from 'zod'

const userFetchDefinition = defineAction({
  ...userFetchAction,

  input: z.object({ id: z.string() }),
  output: z.object({
    data: z.array(
      z.object({
        id: z.string(),
        role: z.string(),
        name: z.string(),
        email: z.string(),
        cpf: z.string().nullish(),
        isEmailVerified: z.boolean().nullish(),
        cns: z.string().nullish(),
        clientId: z.number(),
        deniedPermissionKeys: z.array(z.string()).default([]),
        createdAt: z.date(),
        updatedAt: z.date(),
        firebaseData: z.object({
          displayName: z.string().nullish(),
          photoURL: z.string().nullish(),
          phoneNumber: z.string().nullish(),
          lastSignInTime: z.string().nullish(),
          creationTime: z.string().nullish(),
          disabled: z.boolean(),
          emailVerified: z.boolean(),
        }),
      }),
    ),
    message: z.string(),
  }),
})

export default userFetchDefinition
